<template>
    <span>
        <slot :attempts="attempts" :result="result" :dateTime="dateTime"/>
        <router-link
            :disabled="isProcessing"
            :key="transactionId"
            :to="{name: 'transaction-details', params: {id: transactionId}}">
                {{ transactionId }}
        </router-link>
    </span>
</template>
<script>

    export default {
        name: 'transaction-summary-retry-message',
        props: {
            retry: {
                type: Object,
            },
            linkTransactionId: {
                type: String,
                default: null,
            },
            isProcessing: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        computed: {
            transactionId() {
                return this.linkTransactionId || this.retry.retriedTransactionId;
            },
            attempts() {
                const {retryInstruction, retryNumber} = this.retry;
                const maxRetries = retryInstruction ? retryInstruction.attempts.length : 0;
                return `#${retryNumber} of ${maxRetries}`;
            },
            result() {
                return this.retry.isScheduled ? 'Scheduled' : this.retry.result;
            },
            dateTime() {
                const {scheduledTime, processedTime} = this.retry;
                const executionTime = scheduledTime || processedTime;
                return executionTime ? this.$options.filters.dateTime(executionTime) : 'unknown time';
            },
        },
    };
</script>
